<template>
<v-layout column>
    <v-flex>
        <v-container
          fluid
          grid-list-md
        >
        <div class = "primary">

        <v-subheader class="deliverable"  style="height: 85px">  <img src= "/static/img/official_icons/deliverable.png" style= "max-width: 8ex; max-height: 8ex;">
        <h1 class="deliverable" style="color:white; psition: relative; bottom: 10px">Document Library
      </h1> </v-subheader>
          </div>
            <v-text-field
            append-icon="search"
            box
            placeholder="Search a library..."
            v-model="search"
            >
            </v-text-field>

            <v-switch v-model="final" label="Filter By Tag"></v-switch>
            <v-autocomplete
                          v-model="tagFilters"
                          :items="tags"
                          box
                          chips
                          color="blue-grey lighten-2"
                          label="Select Tags to Filter By"
                          item-text="name"
                          item-value="name"
                          multiple
                          v-show="final"
                        >
                          <template
                            slot="selection"
                            slot-scope="data"
                          >
                            <v-chip
                              :selected="data.selected"
                              close
                              class="chip--select-multi"
                              @input="data.parent.selectItem(data.item)"
                            >
                              {{ data.item }}
                            </v-chip>
                          </template>
                          <template
                            slot="item"
                            slot-scope="data"
                          >
                            <template v-if="typeof data.item !== 'object'">
                              <v-list-tile-content v-text="data.item"></v-list-tile-content>
                            </template>
                            <template v-else>
                              <v-list-tile-content>
                                <v-list-tile-title v-html="data.item"></v-list-tile-title>
                              </v-list-tile-content>
                            </template>
                          </template>
                        </v-autocomplete>

          <v-layout row wrap class="scroll-y" id="scroll-target">
      <v-flex
              v-for="file in searchedFiles"
              v-bind="{ [`xs3`]: true }"
              :key="file.fileURL"
              v-scroll:#scroll-target
        align-center
        justify-center
            >

              <v-card color='grey lighten-2' style="height: 19em; max-width: 260px; min-width:200px">
                <v-card-title primary-title>
                  <h4 v-if="file.title.length < 14" class=" headline mb-0" style="display: block; "><h3 class=" headline mb-0">{{file.title}}</h3> <br>
                  <h5 v-if="file.tags.length !== 0 ">Tags: <template v-for="tag in file.tags">
                  <h5 style="font-size: 13px;" :key="tag" >{{tag}} </h5>
                </template> </h5>
                  </h4>
                <h4 v-if="file.title.length > 14" class=" headline mb-0" style="display: block;"><h3 class=" headline mb-0">{{file.title.substring(0, 14)}}...</h3> <br> <h5 v-if="file.tags.length !== 0 ">Tags: <template v-for="tag in file.tags">
                  <h5 style="font-size: 13px;" :key="tag" >{{tag}} </h5>
                </template></h5></h4>
                </v-card-title>

      <v-card-actions style="position: absolute; bottom: 0px;">
          <v-btn
            color="green"
            dark
            @click="this.window.open(file.fileURL)"
          >
            Open
          </v-btn>
        <v-btn
            v-if="file.projectID !== 0"
            color="primary"
            dark
            @click="funct(file.projectID)"
          >
            Go to Project
          </v-btn>
          <v-dialog v-model="file.fileDialog">
          <v-btn
            slot="activator"
            v-if="file.delete === true"
            color="alerts"
            dark
          >
            Delete
          </v-btn>
          <v-card class style=" width: 100%; height: 150px">
                    <v-card-title >
                      <h2> You want to delete the File: {{file.title}}?</h2>
                      </v-card-title>

                      <v-btn
                    color="alerts"
                    flat
                    dark
                    @click="deletes(file)"
                  >
                    Delete
                  </v-btn>
                    <v-btn
                    color="green"
                    flat
                    dark
                    @click="file.fileDialog = false"
                  >
                    Cancel
                  </v-btn>
                  </v-card>
                  </v-dialog>
      </v-card-actions>
          </v-card>

            </v-flex>
          </v-layout>
        </v-container>
          </v-flex>
          <input type="file" id="selectedFile"  name="fileName" value="fileName" style="display: none;" v-on:change="imageSelected"/>
          <v-dialog v-model="dialog">
          <v-btn slot="activator" color="primary" onclick="document.getElementById('selectedFile').click();">
            Upload Document
          </v-btn>
          <v-card style=" height: 300px" class="deliverable pa-3 ma-3">
            <v-subheader><h1 style="color:white"> Upload A Document </h1></v-subheader>
            <br>
            <h1>{{fileName}}</h1>
          <v-text-field
      label="Document Title"
      required
      v-model="fileTitle"
    ></v-text-field>

<v-autocomplete
              v-model="tag"
              :items="tags"
              box
              chips
              color="blue-grey lighten-2"
              label="Select Tags for your Document"
              item-text="name"
              item-value="name"
              multiple
            >
              <template
                slot="selection"
                slot-scope="data"
              >
                <v-chip
                  :selected="data.selected"
                  close
                  class="chip--select-multi"
                  @input="data.parent.selectItem(data.item)"
                >
                  {{ data.item }}
                </v-chip>
              </template>
              <template
                slot="item"
                slot-scope="data"
              >
                <template v-if="typeof data.item !== 'object'">
                  <v-list-tile-content v-text="data.item"></v-list-tile-content>
                </template>
                <template v-else>
                  <v-list-tile-content>
                    <v-list-tile-title v-html="data.item"></v-list-tile-title>
                  </v-list-tile-content>
                </template>
              </template>
            </v-autocomplete>

    <v-btn flat @click="newFileTime()" class="green" style="color:white">Submit </v-btn>
    <v-btn flat @click="dialog = false" class="primary" style="color:white">Cancel </v-btn>
          </v-card>
          </v-dialog>
    </v-container>
    </v-flex>
    </v-layout>
</template>

<script>

import firebase from '../Firebase/FirebaseInit'
import router from '../router/index.js'

export default {
  data () {
    return {
      files: [],
      router,
      search: '',
      fileTitle: '',
      dialog: false,
      dialog2: [],
      tags: ['Draft', 'Final', 'Image', 'Agenda', 'Presentation', 'Background', 'General', 'Notes', 'Other'],
      tag: null,
      tagFilters: [],
      fileName: '',
      final: false,
      filteredFiles: []
    }
  },
  watch: {
    files (files) {
      this.filteredFiles = files
    },
    tagFilters (filters) {
      if (this.tagFilters.length === 0 || this.final === false) {
        this.filteredFiles = this.files
      } else {
        let filtered = this.files.filter(file => {
          for (var i = 0; i < file.tags.length; i++) {
            if (this.tagFilters.includes(file.tags[i])) {
              return true
            }
          }
          return false
        })
        this.filteredFiles = filtered
      }
    }
  },
  computed: {
    searchedFiles () {
      if (this.tagFilters.length === 0 || this.final === false) {
        this.filteredFiles = this.files
      }
      return this.filteredFiles.filter((file) => file.title.toLowerCase().includes(this.search.toLowerCase()))
    }
  },
  methods: {
    pushProject (projectID) {
      this.$store.dispatch('Project', projectID)
      router.push('/project/' + projectID)
    },
    imageSelected (e) {
      this.newFile = e.target.files[0]
    },
    deletes (file) {
      file.fileDialog = false
      firebase.firestore().collection('users').doc(this.$store.getters.user.id).collection('files').get().then((querySnapshot) => {
        querySnapshot.forEach((docu) => {
          if (file.fileURL === docu.data().file.fileURL) {
            firebase.firestore().collection('users').doc(this.$store.getters.user.id).collection('files').doc(docu.id).delete()
          }
        })
      })
      var filteredAry = this.files.filter(function (e) { return e !== file })
      this.files = filteredAry
    },
    newFileTime () {
      let tagg = (this.tag == null) ? [] : this.tag
      var char = [0, this.newFile, 0, this.fileTitle, this.$store.getters.user.id, tagg]
      this.fileTitle = ''
      this.$store.dispatch('newFile', char)
      this.dialog = false
      this.pullUserFiles()
    },
    funct (projectID) {
      this.$store.dispatch('Project', projectID)
      this.$router.push('/project/' + projectID)
    },
    pullUserFiles () {
      this.files = []
      firebase.firestore().collection('users').doc(this.$store.getters.user.id).collection('files').get().then((querySnapshot) => {
        querySnapshot.forEach((docu) => {
          var file = {
            title: docu.data().file.title,
            fileURL: docu.data().file.fileURL,
            projectID: 0,
            delete: true,
            tags: docu.data().file.tags
          }
          this.files.push(file)
        })
      })
      firebase.firestore().collection('users').doc(this.$store.getters.user.id).collection('projects').get().then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          let projectID = doc.data().projectID
          firebase.firestore().collection('projects').doc(projectID).get().then((docu) => {
            if (docu.data().files.length !== 0) {
              for (var i = 0; i < docu.data().files.length; i++) {
                var file = {
                  title: docu.data().files[i].title,
                  fileURL: docu.data().files[i].fileURL,
                  projectID: projectID,
                  delete: false,
                  fileDialog: false,
                  tags: docu.data().files[i].tags
                }
                this.files.push(file)
              }
            }
          })
        })
      })
    }
  },
  beforeCreate () {
    firebase.firestore().collection('users').doc(this.$store.getters.user.id).collection('files').get().then((querySnapshot) => {
      querySnapshot.forEach((docu) => {
        var file = {
          title: docu.data().file.title,
          fileURL: docu.data().file.fileURL,
          projectID: 0,
          delete: true,
          tags: docu.data().file.tags
        }
        this.files.push(file)
      })
    })
    firebase.firestore().collection('users').doc(this.$store.getters.user.id).collection('projects').get().then((querySnapshot) => {
      querySnapshot.forEach((doc) => {
        let projectID = doc.data().projectID
        firebase.firestore().collection('projects').doc(projectID).get().then((docu) => {
          if (docu.data().files.length !== 0) {
            for (var i = 0; i < docu.data().files.length; i++) {
              var file = {
                title: docu.data().files[i].title,
                fileURL: docu.data().files[i].fileURL,
                projectID: projectID,
                delete: false,
                fileDialog: false,
                tags: docu.data().files[i].tags
              }
              this.files.push(file)
            }
          }
        })
      })
    })
  }
}
</script>



// WEBPACK FOOTER //
// Library.vue?8d9a4e74